import axios from "axios"
import { useEffect, useState } from "react"
import { Form, Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { DEV_SERVER } from "../../../constants/urls"
import { userSignal } from "../../../signal/userSignal"
import { toast } from "react-toastify"
import * as moment from "moment"
import Select from "react-select"


export default function AddEditVisual(props) {

    const [visual, setVisual] = useState({
        name: "",
        type: "folder",
        url: "",
        updatedAt: 0
    })
    const [medias, setMedias] = useState([])
    const [edit, setEdit] = useState(false)
    const [oldName, setOldName] = useState("")

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    let temp = []
                    data?.data?.data.map((media) => {
                        temp.push({
                            url: media?.url,
                            type: "file",
                            name: media?.url?.split("/")[media?.url?.split("/").length - 1],
                            updatedAt: moment(Date.now()).valueOf()
                        })
                    })
                    setMedias((prev) => [...prev, ...temp])
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleImageUpload = (e) => {
        let data = new FormData();
        for (let i = 0; i < e.target.files?.length; i++) {
            data.append("media", e.target.files[i])
        }
        imageUploadMutation.mutate(data)
    }

    const handleSubmit = () => {

        if (visual?.type === "folder" && visual?.name === "") {
            toast.error("Please enter name")
            return
        }

        if (visual?.type === "file" && medias.length === 0) {
            toast.error("Please upload media")
            return
        }

        if (visual?.type === "file") {
            props?.handleUpdateVisuals(medias)
        } else {

            props?.handleUpdateFolder({
                ...visual,
                updatedAt: moment(Date.now()).valueOf()
            }, oldName)
        }
    }

    useEffect(() => {
        if (props?.visual) {
            setVisual(props?.visual)
            setOldName(props?.visual?.name)
            setEdit(true)
        } else {
            setVisual({
                name: "",
                type: "",
                url: "",
                updatedAt: 0
            })
            setEdit(false)
        }
    }, [])

    return (
        <Modal show={props?.show} onHide={() => props?.close()} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{edit ? "Edit" : "Add"} Visual</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="d-flex flex-column">
                    <Form.Group className="mb-3" controlId="formBasicType">
                        <Form.Label>Type</Form.Label>
                        <Select
                            isDisabled={edit}
                            value={{ value: visual?.type, label: visual?.type }}
                            onChange={(e) => setVisual({ ...visual, type: e.value })}
                            options={[
                                { value: "folder", label: "Folder" },
                                { value: "file", label: "Visual" }
                            ]}
                        />
                    </Form.Group>
                    {visual?.type === "folder" &&
                        <Form.Group className="mb-3" controlId="formBasicName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" value={visual?.name} onChange={(e) => setVisual({ ...visual, name: e.target.value })} />
                        </Form.Group>
                    }


                    {visual?.type === "file" && <Form.Group className="mb-3 mt-3 col-4" controlId="formBasicImages">
                        <Form.Label>Media</Form.Label>
                        <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ columnGap: "0.5rem" }}>

                            {(medias?.length && medias?.length !== 0) && medias.map((item, i) => {
                                return <div key={i} className="mt-3" style={{ width: "30px", height: "30px", margin: "0.5rem", position: "relative" }}>
                                    <img
                                        style={{ height: "100%", width: "100%" }}
                                        className="d-block w-100"
                                        src={item.url}
                                        alt="First slide"
                                    />
                                    <span onClick={() => {
                                        let images = medias;
                                        images.splice(i, 1);
                                        setMedias([...images])
                                    }} className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        <i style={{ cursor: "pointer" }} className="fas fa-times"></i>
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                </div>
                            })}

                            <button disabled={imageUploadMutation.isLoading} className="btn btn-primary mt-3 d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                <i className="fas fa-upload"></i>
                                <input onClick={(e) => { e.target.value = null }} onChange={(e) => handleImageUpload(e)} type="file" multiple style={{ width: "50px", height: "50px", position: "absolute", top: "0", left: "0", opacity: "0", cursor: "pointer" }} />
                            </button>
                        </div>
                    </Form.Group>}
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => props?.close()}>Close</button>
                <button className="btn btn-primary" onClick={() => {
                    handleSubmit()
                }}>{edit ? "Edit" : "Add"}</button>
            </Modal.Footer>
        </Modal>
    )
}